var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1953 6.5C15.1953 6.74623 15.0966 6.98237 14.9208 7.15648C14.745 7.33059 14.5065 7.4284 14.2579 7.4284L3.39725 7.4284L7.42243 11.4131C7.59845 11.5874 7.69733 11.8239 7.69733 12.0704C7.69733 12.317 7.59845 12.5534 7.42243 12.7277C7.24641 12.9021 7.00768 13 6.75875 13C6.50983 13 6.2711 12.9021 6.09508 12.7277L0.470706 7.15731C0.383411 7.07107 0.314151 6.96862 0.266894 6.85583C0.219637 6.74304 0.195312 6.62212 0.195312 6.5C0.195312 6.37788 0.219637 6.25697 0.266894 6.14417C0.314151 6.03138 0.383411 5.92893 0.470706 5.84269L6.09508 0.272266C6.2711 0.0979374 6.50983 7.59309e-07 6.75875 7.37547e-07C7.00768 7.15785e-07 7.24641 0.0979373 7.42243 0.272266C7.59845 0.446596 7.69733 0.683037 7.69733 0.929577C7.69733 1.17612 7.59845 1.41256 7.42243 1.58689L3.39725 5.5716L14.2579 5.5716C14.5065 5.5716 14.745 5.66941 14.9208 5.84352C15.0966 6.01763 15.1953 6.25377 15.1953 6.5Z",
    fill: "#82BE41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.95986a9efcbdb60f44555bce15e94ef1.svg";
export { ForwardRef as ReactComponent };